var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollabs = function SvgCollabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 69 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M66.901 32.331c-.22-5.137-1.97-10.208-5.178-14.238a27.45 27.45 0 0 0-1.04-1.218c-.155-.177-.31-.332-.465-.51-.11-.11-.222-.243-.332-.354l-3.276-3.233s-.973 2.945-.885 3.145c1.062 2.59 9.583 20.394 3.497 30.425C51.255 60.742 30.916 69.4 16.376 59.59a23.313 23.313 0 0 1-1.837-1.373c-.022 0-.044-.044-.067-.066a21.092 21.092 0 0 1-1.261-1.152l3.275 3.233c3.453 3.41 8.056 5.736 13.478 6.51 12.726 1.75 25.43-5.624 32.069-16.297 3.32-5.381 5.245-11.758 4.935-18.114H66.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M22.24 30.075c-1.084 2.126-1.704 4.518-1.748 6.887-.045 2.126.464 4.318 1.416 6.112.752 1.505 1.86 2.79 3.187 3.808.243.178.487.377.752.532-.066-.111-.155-.222-.22-.332-1.019-1.683-1.616-3.61-1.793-5.559-.377-4.428 1.438-8.901 4.404-12.134 3.496-3.875 8.83-6.245 14.053-5.536 1.859.265 3.497.908 4.913 1.838a11.146 11.146 0 0 0-1.682-1.993c-7.303-6.798-19.387-1.86-23.304 6.377h.022Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#72E9CA",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M16.33 59.594c14.563 9.81 34.88 1.13 42.847-13.242 6.086-10.031 6.396-24.27-2.08-33.038-3.497-3.699-8.278-6.223-13.965-7.02C27.928 4.146 11.86 15.24 7.302 31.029c-3.121 10.828-.045 21.058 7.125 27.126.023 0 .045.044.067.066.575.487 1.195.952 1.837 1.373Zm4.161-22.653c.045-2.37.642-4.761 1.749-6.887 3.917-8.26 15.979-13.175 23.304-6.377a11.149 11.149 0 0 1 1.682 1.993c1.992 3.011 2.656 6.997 1.438 11.182-2.28 7.884-10.29 13.42-17.904 12.357-1.859-.266-3.497-.886-4.913-1.816a22.181 22.181 0 0 1-.752-.532c-1.328-1.018-2.435-2.303-3.187-3.808-.952-1.794-1.439-3.986-1.417-6.112Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5C5D",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "m56.652 12.838-4.094-4.03c.221.221.42.42.62.642l3.651 3.587s-.11-.155-.177-.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D5F60",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M54.547 11.056s.044.044.066.088l4.05 3.986v-.044a4.254 4.254 0 0 1-.31-.332 27.585 27.585 0 0 0-1.505-1.705L53.197 9.46s.199.222.287.333l.797.93c.089.11.177.199.266.31v.022Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#606263",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M54.814 11.409c.288.376.553.774.819 1.173.11.155.221.288.31.443l4.005 3.942a21.369 21.369 0 0 0-1.283-1.86l-4.05-3.986.199.265v.023Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "m56.166 13.397 4.094 4.03c-.088-.155-.221-.287-.31-.442l-4.005-3.942c.066.11.154.244.22.354Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M56.162 13.398 43.48 22.145l.11.089 3.984 3.941 12.681-8.746-4.094-4.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M10.905 54.57c5.976 4.827 14.342 6.2 21.8 4.472a33.59 33.59 0 0 0 10.756-4.517c.354-.221.686-.42 1.04-.664l-6.839-11.493c-3.253 2.237-7.148 3.366-10.955 2.813-5.577-.71-9.826-5.315-10.202-10.895-.288-3.322.664-6.71 2.412-9.544 3.32-5.36 9.671-9.035 16.045-8.171 2.434.354 4.758 1.395 6.551 3.1.775.73 1.46 1.55 1.992 2.458l12.659-8.747a26.312 26.312 0 0 0-.531-.82c-.266-.398-.531-.796-.82-1.173l-.53-.664c-.266-.31-.51-.62-.797-.93a23.125 23.125 0 0 0-9.207-6.223 24.584 24.584 0 0 0-5.245-1.306c-3.585-.51-7.37-.288-11.154.686-5.688 1.462-11.043 4.518-15.425 8.791-4.382 4.274-7.614 9.589-9.251 15.235-1.638 5.67-1.594 11.426.066 16.564a22.964 22.964 0 0 0 7.06 10.562c.177.155.354.31.531.443l.044.022Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "m41.733 46.419-4.072-4.052 6.816 11.492 4.094 4.03-6.838-11.47Zm1.751-24.273a11.824 11.824 0 0 0-1.991-2.458c-1.793-1.705-4.117-2.723-6.551-3.1-6.374-.863-12.748 2.813-16.045 8.171-1.749 2.835-2.678 6.223-2.413 9.544.266 3.942 2.501 7.374 5.732 9.3v-.066a2.245 2.245 0 0 1-.265-.42c-1.306-2.459-1.704-5.36-1.262-8.105.664-4.518 3.342-8.658 7.016-11.294.177-.132.332-.243.509-.376 3.143-2.126 7.015-3.233 10.822-2.724a12.31 12.31 0 0 1 4.559 1.617v-.177l-.088.088h-.023Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.31,
    d: "M43.462 54.528c-3.297 2.126-6.949 3.676-10.755 4.517-7.459 1.727-15.824.354-21.8-4.473a9.079 9.079 0 0 1-.53-.443c-.377-.31-.731-.642-1.085-.974-.067-.067-.155-.133-.221-.2l4.094 4.03a22.702 22.702 0 0 0 3.585 2.88c2.944 1.926 6.33 3.166 9.937 3.675a26.78 26.78 0 0 0 5.51.2c5.622-.377 11.088-2.348 15.78-5.448.2-.133.42-.266.62-.398l-4.094-4.03c-.332.243-.686.442-1.04.664Z"
  })));
};
export default SvgCollabs;